export default {
    data() {
        return {
            isLoading: true,
        };
    },
};